const theme = {
  colors: {
    primary: '#0784a7',
    primaryLight: '#0a94bc',
    primaryDark: '#065f7a',
    primaryGhost: 'rgba(7, 132, 167, 0.08)',

    background: '#f5f7fa',
    surface: '#ffffff',
    surfaceHover: '#f8fafb',

    text: '#1a2b3d',
    textSecondary: '#64748b',
    textMuted: '#94a3b8',

    border: '#e2e8f0',
    borderLight: '#f1f5f9',

    success: '#10b981',
    successLight: '#ecfdf5',
    warning: '#f59e0b',
    warningLight: '#fffbeb',
    danger: '#ef4444',
    dangerLight: '#fef2f2',
    info: '#3b82f6',
    infoLight: '#eff6ff',

    // Meeting type accent colors
    elevatorPitch: '#3c3c3c',
    casualEncounter: '#186d9a',
    salesPresentation: '#11244f',
    investorPitch: '#11244f',
    qaPractice: '#7b2d8e',
    dealCoaching: '#5c2d91',

    // Sidebar
    sidebarBg: '#0f2b3d',
    sidebarText: '#94b8c8',
    sidebarTextActive: '#ffffff',
    sidebarHover: 'rgba(255, 255, 255, 0.08)',
    sidebarActive: 'rgba(7, 132, 167, 0.3)',
    sidebarDivider: 'rgba(255, 255, 255, 0.1)',
  },

  typography: {
    fontFamily: "'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif",
    h1: { size: '24px', weight: 700, lineHeight: '1.3' },
    h2: { size: '20px', weight: 600, lineHeight: '1.3' },
    h3: { size: '16px', weight: 600, lineHeight: '1.4' },
    body: { size: '14px', weight: 400, lineHeight: '1.5' },
    small: { size: '12px', weight: 400, lineHeight: '1.5' },
    tiny: { size: '10px', weight: 500, lineHeight: '1.4' },
  },

  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
  },

  shadows: {
    sm: '0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04)',
    md: '0 4px 12px rgba(0, 0, 0, 0.08)',
    lg: '0 8px 24px rgba(0, 0, 0, 0.12)',
    glow: '0 0 20px rgba(7, 132, 167, 0.15)',
  },

  radii: {
    sm: '6px',
    md: '10px',
    lg: '16px',
    full: '9999px',
  },

  transitions: {
    fast: '0.15s ease',
    normal: '0.25s ease',
    slow: '0.35s ease',
  },

  layout: {
    sidebarWidth: '240px',
    sidebarCollapsed: '64px',
    topBarHeight: '56px',
    contentMaxWidth: '1200px',
    contentPadding: '32px',
    contentPaddingMobile: '16px',
  },

  breakpoints: {
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px',
  },

  media: {
    mobile: '@media (max-width: 480px)',
    tablet: '@media (max-width: 768px)',
    desktop: '@media (max-width: 1024px)',
  },
};

export default theme;
